import * as React from 'react';
import { SVGProps } from 'react';

const FileIconDocSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <g opacity={0.5} fill="#fff">
      <path d="M5 14h14v-1H5v1ZM5 17h14v-1H5v1ZM19 20H5v-1h14v1ZM5 23h7v-1H5v1Z" />
    </g>
    <path
      d="M8 8.77c-.22.153-.487.23-.8.23h-.5c-.587 0-1.017-.123-1.29-.37C5.137 8.377 5 7.967 5 7.4V5.6c0-.56.137-.967.41-1.22.28-.253.77-.38 1.35-.38H8V2h1v7H8v-.23ZM7.35 8c.22 0 .383-.057.49-.17A.566.566 0 0 0 8 7.45V5H6.75c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.6ZM14 7.4c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-.6c-.58 0-1.01-.127-1.29-.38-.273-.253-.41-.66-.41-1.22V5.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38h.6c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22v1.8Zm-1-1.75c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.5c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.5c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7ZM16.71 9c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V5.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38H18v1h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17H18v1h-1.29Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconDocSizeS;
